
jQuery( ( $ ) => {

	// Fetched asynchronously without blocking below so the add-to-basket
	// enable/disable handlers are bound immediately on page load, not after
	// this request resolves.
	const translationsPromise = $.get( red61.ajax_url, { action: 'get_translations', component: 'productPage' } )
		.then( ( productTranslations ) => {
			window.translations = {
				...productTranslations.translations
			};
			return productTranslations.translations;
		} );

	$( '.voucher-js .voucher-item select' ).change( function() {
		if ( 0 < this.value ) {
			$( this )
				.closest( '.voucher-item' )
				.find( '.add-to-basket' )
				.removeClass( 'disabled-btn-state' )
				.prop( 'disabled', false );

		}
		else {
			$( this ).closest( '.voucher-item' )
				.find( '.add-to-basket' )
				.addClass( 'disabled-btn-state' )
				.prop( 'disabled', true );

		}
	} );

	$( '.voucher-js .add-to-basket' ).click( async function( event ) {
		event.preventDefault();
		const voucherFundRef = $( this ).closest( '.voucher-item' ).find( 'input[name="voucher"]' ).val();
		const voucherFundRefCssClass = voucherFundRef.replace( ':', '-' );

		const response = await addToBasket( $( this ) );
		const translations = await translationsPromise;

		updateBasketMessage( response.message, voucherFundRefCssClass, translations );
		if ( response.basket ) {
			$( '.cart-btn .price' ).text( response.basket.total );
		}
		if ( 'alert-success' === response.message.className ) {
			$( this ).closest( '.voucher-item' ).find( '.qty-select-vouchers' ).val( 0 );
			$( this ).addClass( 'disabled-btn-state' );
		}
	} );
    
	function updateBasketMessage( message, voucherRef, translations ) {
    
		const pageURL = `${window.location.href  }`;
		const pageURLwithPolyLang = pageURL.replace( 'vouchers', 'basket' );
    
		$( `.basket-message-${voucherRef}` ).text( message.text );
		if( 'alert-success' === message.className ){
			const goToCheckout = _.template(
				'<%- translations[ "GO TO CHECKOUT" ] || "GO TO CHECKOUT" %>'
			);
			$( `.basket-message-${voucherRef}` ).append( `<a class="underline" href="${ pageURLwithPolyLang }">${ goToCheckout( translations ) }</a>` );
		}
		$( `.basket-message-${voucherRef}` ).attr( 'class', `alert ${message.className} basket-message` );
    
	}
    
	async function addToBasket( $button ) {
		$( '.basket-message' ).addClass( 'd-none' );
		$button.addClass( 'disabled-btn-state' );
    
		const formData = new FormData();
		formData.append( 'action', 'add_voucher_to_basket' );
		formData.append( 'voucher',
			$button.closest( '.voucher-item' ).find( 'input[name="voucher"]' ).val(),
		);
		formData.append( 'amount',
			$button.closest( '.voucher-item' ).find( '.qty-select-vouchers' ).val(),
		);
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();
    
		$button.removeClass( 'disabled-btn-state' );
		return response;
	}
    
	// MOBILE 
    
    
	$( '.voucher-js .voucher-item select' ).change( function() {
		if ( 0 < this.value ) {
			$( this )
				.closest( '.voucher-item' )
				.find( '.vouchers-add-to-basket-mobile' )
				.removeClass( 'disabled-btn-state' )
				.prop( 'disabled', false );
		}
		else {
			$( this ).closest( '.voucher-item' )
				.find( '.vouchers-add-to-basket-mobile' )
				.addClass( 'disabled-btn-state' )
				.prop( 'disabled', true );
		}
	} );
    
	$( '.voucher-js .vouchers-add-to-basket-mobile' ).click( async function( event ) {
		event.preventDefault();
            
		const voucherFundRef = $( this ).closest( '.voucher-item' ).find( 'input[name="voucher"]' ).val();
		const voucherFundRefCssClass = voucherFundRef.replace( ':', '-' );
            
		const response = await addToBasket( $( this ) );
    
		updateBasketMessageMobile( response.message, voucherFundRefCssClass );
		if ( response.basket ) {
			$( '.cart-btn .price' ).text( response.basket.total );
		}
		if ( 'alert-success' === response.message.className ) {
			$( this ).closest( '.voucher-item' ).find( '.qty-select-vouchers' ).val( 0 );
			$( this ).addClass( 'disabled' ); 
			$( '.vouchers-checkout-mobile' ).each( function(){
				if( !( $( this ).hasClass( 'display-none' ) ) ){
					$( this ).addClass( 'display-none' );
				}
			} );
			$( this ).closest( '.voucher-item' ).find( '.vouchers-checkout-mobile' ).removeClass( 'display-none' );
		}
	} );
    
    
	function updateBasketMessageMobile ( message, voucherRef ) {
		$( `.basket-message-${voucherRef}` ).text( message.text );
		$( `.basket-message-${voucherRef}` ).attr( 'class', `alert ${message.className} basket-message vouchers-basket-response-alert-mobile ` );
    
	}
    
} );